import { render, staticRenderFns } from "./ganhuo-detail.vue?vue&type=template&id=62d18840&scoped=true&"
import script from "./ganhuo-detail.vue?vue&type=script&lang=js&"
export * from "./ganhuo-detail.vue?vue&type=script&lang=js&"
import style0 from "./ganhuo-detail.scss?vue&type=style&index=0&id=62d18840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d18840",
  null
  
)

export default component.exports